import { render } from "./AnimesCount.vue?vue&type=template&id=a49eea3e"
import script from "./AnimesCount.vue?vue&type=script&lang=js"
export * from "./AnimesCount.vue?vue&type=script&lang=js"

import "./AnimesCount.vue?vue&type=style&index=0&id=a49eea3e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__